import md5 from "blueimp-md5";
import React from "react";
import styled from "styled-components";

const AvatarImage = styled.img`
  display: block;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  border: 1px solid ${(p) => p.theme.borderDefault};
`;

interface AvatarProps {
  className?: string;
  email?: string;
  title: string;
}
export const Avatar = (props: AvatarProps) => {
  const { className, email = "john.doe@example.com", title } = props;

  return (
    <AvatarImage
      className={className}
      title={title}
      src={`https://secure.gravatar.com/avatar/${md5(
        email.toLowerCase().trim(),
      )}?s=${120}&d=${encodeURIComponent("mm")}`}
      alt={`${title} avatar`}
    />
  );
};
